<div class="assets-page-wrapper">
  <vs-app-page
    [config]="{
      title: 'Assets',
      icon: 'package',
      isSubPage: true
    }"
  >
    <vs-tab-nav slot="sticky" theme="primary" [config]="{ items: tabs }"></vs-tab-nav>

    <router-outlet></router-outlet>
  </vs-app-page>
</div>
